import * as actions from "Actions";
import * as api from "Api";

export const fetchParameterSettings = year => {
  return (dispatch, getState) => {
    const {
      auth: {
        currentOrganization: { id }
      }
    } = getState();
    return dispatch(
      actions.getParameterSettings(api.getParameterSettings(id, year))
    );
  };
};

export const saveParameterSettings = year => (dispatch, getState) => {
  const {
    auth: { currentOrganization },
    parameterSettings: {
      data: {
        synchro,
        synchroRole,
        synchroEntity,
        benchmarkValue,
        defaultAuthParameters,
        priceList
      }
    }
  } = getState();
  return dispatch(
    actions.saveParameterSettings(
      api.saveParameterSettings(
        currentOrganization,
        year,
        synchro,
        synchroRole,
        synchroEntity,
        benchmarkValue,
        defaultAuthParameters,
        priceList
      )
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/parameter-settings.js